import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zBom2a = z.object({
  id: zUid,
  name: z.string(),
});

export type ZBom2a = z.infer<typeof zBom2a>;

export type Bom2aFilters = {};
